import script from "./Switch.vue?vue&type=script&setup=true&lang=js"
export * from "./Switch.vue?vue&type=script&setup=true&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=7f7ed79e&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7ed79e"]])

export default __exports__